<template>
    <aside
        class="patsnap-biz-master_nav master_nav"
        role="navigation"
        :aria-expanded="service.isWide?'true':'false'"
    >
        <a
            class="master_nav__trigger"
            flex="-"
            tabindex="0"
            role="button"
            @click="onClickTrigger"
            @keydown.enter.prevent="onClickTrigger"
            @keydown.space.prevent="onClickTrigger"
        >
            <div
                v-if="service.isWide"
                class="master_nav__trigger__icon-wrap"
                flex-item=")0(center"
            ><ToggleIcon :value="service.isWide" /></div>
            <ElTooltip
                v-else
                popper-class="master_nav__tip"
                effect="dark"
                placement="right"
                :visible-arrow="false"
                :disabled="service.isWide"
                :content="service.$t('expandSidebar')"
            >
                <div class="master_nav__trigger__icon-wrap"><ToggleIcon :value="service.isWide" /></div>
            </ElTooltip>

            <div
                v-show="service.isWide"
                class="master_nav__trigger__text"
                flex-item="()center"
            >
                {{ service.$t('hideSidebar') }}
            </div>
        </a>
        <DivLine
            class="master_nav__top-divline"
            label=""
        />
        <nav>
            <template v-for="(partition, partIndex) in service.partitions">
                <slot
                    v-if="typeof partition === 'string' && getSlotName(partition)"
                    :service="service"
                    :name="getSlotName(partition)"
                />
                <DivLine
                    v-else-if="typeof partition === 'string' && !getSlotName(partition)"
                    :key="`divLine_${partIndex}`"
                    :label="service.$t(partition)"
                />
                <NavItem
                    v-else
                    :key="partition.key"
                    class="master_nav__item__node"
                    :info="partition"
                    :service="service"
                    @onClick="(o) => service.onClickedLinkHook(o.key, o)"
                    @onClickExpand="key => service.toggleExpandLv2(key)"
                    @onSlotChange="getSlots"
                >
                    <template
                        v-for="slot in slots"
                        #[slot]="{ handler }"
                    >
                        <slot
                            :name="slot"
                            :handler="handler"
                        />
                    </template>
                </NavItem>
            </template>
        </nav>
    </aside>
</template>

<script>
import ElTooltip from 'element-ui/lib/tooltip';
import ToggleIcon from './components/ToggleIcon';
import '@patsnap-ui/icon/assets/solid/ArrowsmallDown.svg';
import '@patsnap-ui/icon/assets/solid/ArrowSmallUp.svg';

import NavService from './NavService';
import DivLine from './components/DivLine';
import NavItem from './NavItem.vue';

export default {
    name: 'PtMasterNav',
    components: {
        ElTooltip,
        ToggleIcon,
        DivLine,
        NavItem,
    },
    props: {
        service: {
            type: Object,
            default() { return new NavService(); },
        },
    },
    data() {
        return {
            slots: [],
        };
    },
    methods: {
        getSlotName(str) {
            const namespace = 'slot:';
            return str.indexOf(namespace) === 0 ? str.replace(namespace, '') : '';
        },
        onClickTrigger() {
            // eslint-disable-next-line vue/no-mutating-props
            this.service.isWide = !this.service.isWide;
        },
        getSlots(slots) {
            this.slots.push(...slots);
            this.slots = Array.from(new Set(this.slots));
        },
    },
};
</script>
